import { api } from '../lib/api';

export class AdminApi {
  async getAllOrders(token) {
    return await api.post(`ApiOrdes/getAllOrders`, { token });
  }
}
